import PropTypes from 'prop-types';
import { Autocomplete, Grid, Stack, TextField, Typography } from '@mui/material';
import Iconify from '../../../../../reusable-components/iconify';

BookingTypeStep.propTypes = {
  editableVendorBookingTypes: PropTypes.array,
  selectedBookingTypeId: PropTypes.number,
  onSelect: PropTypes.func,
};

export function BookingTypeStep({ editableVendorBookingTypes, selectedBookingTypeId, onSelect }) {
  return (
    <Stack spacing={3} justifyContent="center" sx={{ px: 8 }}>
      <Typography variant="subtitle1" sx={{ mb: 1 }}>
        Booking Type
      </Typography>
      <Autocomplete
        size="small"
        isOptionEqualToValue={(option, value) => option?.id === value?.id}
        value={editableVendorBookingTypes?.find((bt) => bt.id === selectedBookingTypeId) ?? null}
        options={editableVendorBookingTypes}
        onChange={(_, newValue) => onSelect(newValue?.id || 0)}
        getOptionLabel={(option) => option?.name ?? ''}
        renderInput={(params) => <TextField {...params} label="Search or select" autoComplete="off" />}
        renderOption={(props, option) => (
          <Grid {...props} justifyContent="space-between">
            <Grid item xs={10}>
              {option.name}
            </Grid>
            <Grid item xs={2} display="flex" alignItems="center">
              <Iconify icon={option.facilityAccountId === "QuickbooksId" ? "simple-icons:quickbooks" : "simple-icons:sage"} />
            </Grid>
          </Grid>
        )}
        sx={{
          width: '95%',
          mt: 1,
          '& legend': { display: 'none' },
          '& fieldset': { top: 0 },
          '& .MuiFormLabel-root': { display: 'none' },
        }}
      />
    </Stack>
  );
}
